import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import { inlinePresentationSelector } from 'selectors/call';
import { CALL_LAYOUT } from 'constants/InCall/InCallVideo';
import CallLayout from 'components/InCall/CallLayout';
import _get from 'lodash/get';
import {
  callSelectors,
  featureSelectors,
  nucleusConstants
} from '@lifesize/nucleus';

const mapActionCreators = (dispatch, ownProps) => ({
  toggleMinimized: () => dispatch(actions.toggleMinimized(ownProps.history.push)),
  handleResizeContainer: container => dispatch(actions.handleResizeContainer(container))
});

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const hasVideo = _get(state, 'app.inCallVideo.shouldDisplayPrimaryVideo') && activeCall.hasIncomingVideo;
  const inlinePresentation = inlinePresentationSelector(state);
  const showExtensionInstallation = _get(state, 'app.extension.showExtensionInstallation');
  const waitingForInstall = _get(state, 'app.extension.waitingForInstall');

  return ({
    callLayoutId: CALL_LAYOUT,
    hasSlide: !!_get(state, 'app.inCallVideo.slide'),
    hasVideo,
    inlinePresentation,
    isMinimized: _get(state, 'app.inCallVideo.isMinimized'),
    showExtensionInstallation,
    showLocalConferenceSlides: featureSelectors.getFeatureFlag(state)(
      nucleusConstants.FEATUREFLAG_SHOW_LOCAL_CONFERENCE_SLIDES
    ),
    waitingForInstall
  });
};

export default connect(mapStateToProps, mapActionCreators)(CallLayout);
